import { BadgeVariants } from '@carboledger/ui';
import { SHIPMENT_STATUS_TONE } from '@/config/statusTones';

// The discrepancy modal's field sections — one builder per view model.

/** From a shipments-list row, in whichever unit the row is showing. */
export const buildShipmentRowDiscrepancySections = (t, row, unitType) => {
  if (!row) return [];
  const unit = row.byUnit?.[unitType ?? row.unitType] ?? {};
  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        { label: t('FIELD_MATERIAL_NAME'), value: row.materialName },
        { label: t('FIELD_SENT_BY'), value: row.supplierName },
        { label: t('FIELD_RECEIVED_AT'), value: row.facilityName },
        { label: t('FIELD_TERMINAL'), value: row.terminal },
      ],
    },
    {
      title: t('SECTION_QUANTITY'),
      fields: [
        { label: t('FIELD_SHIPMENT_QUANTITY'), value: unit.shipmentQuantity },
        {
          label: t('FIELD_RECEIVED_DECLARATION_QUANTITY'),
          value: unit.receivedDeclarationQuantity,
        },
        { label: t('FIELD_AVAILABLE_QUANTITY'), value: unit.availableQuantity },
      ],
    },
  ];
};

/** From the shipment details view model, which holds one set of quantities per unit. */
export const buildShipmentDiscrepancySections = (t, shipment) => {
  if (!shipment) return [];
  const quantities = shipment.workingQuantities ?? {};
  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        { label: t('FIELD_MATERIAL_NAME'), value: shipment.materialName },
        {
          label: t('FIELD_STATUS'),
          value: shipment.status,
          type: 'status',
          tone: SHIPMENT_STATUS_TONE[shipment.statusCode] ?? BadgeVariants.default,
        },
        { label: t('FIELD_SENT_BY'), value: shipment.supplierName },
        { label: t('FIELD_RECEIVED_AT'), value: shipment.facilityName },
        { label: t('FIELD_TERMINAL'), value: shipment.terminal },
        { label: t('FIELD_DATE_OF_DISPATCH'), value: shipment.dateOfDispatch },
      ],
    },
    {
      title: t('SECTION_QUANTITY'),
      fields: [
        { label: t('FIELD_SHIPMENT_QUANTITY'), value: quantities.shipmentQuantity },
        {
          label: t('FIELD_RECEIVED_DECLARATION_QUANTITY'),
          value: quantities.receivedDeclarationQuantity,
        },
        { label: t('FIELD_AVAILABLE_QUANTITY'), value: quantities.availableQuantity },
      ],
    },
  ];
};
